// In the GitHub repository, you'd be able to find the old version with the scroller.

import React, {useDebugValue, useState} from "react";
import IsMobile from "../IsMobile";
import { HomeBannerData } from "../Data Types/HomeBannerData";

// NewsPostData.tsx is a generic news data, both for the small list panels, and the full large view.
// Out of it, some of the data will be here in these props:
type WipBannerElementProps = {
    newsId: string;
    title: string;
    panelClickUrl?: string;  // The primary associated media.

    bannerUrl?: string;
    isPixelated?: boolean;
}
const HomeBannerElement = ({newsId, title, panelClickUrl, bannerUrl, isPixelated = false}: WipBannerElementProps) => {
    const hasPanelClickUrl = panelClickUrl != null;

    // Overrides <a/> appearance. Cursor stays the same though, because clicking on a news panel causes a news post to be displayed.
    const unclickableStyle: any = {
            //pointerEvents: ("none style" as React.CSSProperties["pointerEvents"]),
            cursor: "pointer",
            textDecoration: "none",
            color: "#fff",
        };
    const renderThumbnailAsPixelArt: any = isPixelated ?
        { imageRendering: "pixelated",}
        :
        {};

    function OnClick(/*eventvar*/){
        console.log(`setSelectedPostId(${newsId});`);
        window.open(panelClickUrl, "_blank");
    }

    const isMobile = IsMobile();
    const newsPanelWidthWithoutCarouselArrows = "80%";  // 100 - 10 - 10. News panel has 2 arrows to its sides.

    // TODO: Have a tiny overlay icon button: <a href={panelClickUrl}/>
    return (
      <a
        onClick={OnClick}
        className="banner-panel" // Would have changed the name if the .css wasn't effected. I'll remove this stuff later on.
        style={{
          position: "relative",
          marginBottom: isMobile ? 0 : "8px",
          // TODO: 13vh is a hardcoded value. Perhaps for mobile, allow the hiding of the side text?
          // Or, much more correctly, the banner was always supposed to be a single image anyway. This is ok as a temporary measure.
          width: isMobile ? "newsPanelWidthWithoutCarouselArrows" : "",
          height: isMobile ? "auto" : "inherit",
          maxHeight: isMobile ? "7.5vh" : "inherit",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          aspectRatio: "16 / 3",
          ...unclickableStyle,
        //   maxWidth: "100%",
        }}
      >
        <img
          style={{
            aspectRatio: "16/3",
            ...renderThumbnailAsPixelArt,
            // height: "auto",
            // object-fit: contain;*/
            maxWidth: "100%",
          }}
          src={
            bannerUrl == null
              ? "/Images/YouTube Video Thumbnails/Music/Default Thumbnail.jpg"
              : bannerUrl
          }
        />

        {panelClickUrl && (
          <div
            style={{
              position: "absolute",
              top: "2px",
              right: "2px",
              width: "20px",
              height: "20px",
              backgroundColor: "#00000080",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              onClick={(e) => {
                e.stopPropagation(); // Prevent outer <a> from triggering
                window.open(panelClickUrl, "_blank");
              }}
            >
              {/*https://icons.getbootstrap.com/icons/link/*/}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16px"
                height="16px"
                fill="#d77bba"
                className="bi bi-link"
                viewBox="0 0 16 16"
              >
                <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z" />
                <path d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4 4 0 0 1-.82 1H12a3 3 0 1 0 0-6z" />
              </svg>
            </div>
          </div>
        )}
      </a>
    );
}


type HomeBannerElementScrollerProps = {
    bannerElements: React.JSX.Element[];  // ASSUMPTION: These are of the type <NewsPanelElement/>.
}
const HomeBannerElementScroller = ({bannerElements,}: HomeBannerElementScrollerProps) => {
    const useBannerIndex = () =>{
        const [bannerIndex, setBannerIndex] = useState(0);
        useDebugValue(bannerIndex, b => b);
        return {bannerIndex, setBannerIndex};
    }
    
    const {bannerIndex, setBannerIndex} = useBannerIndex();
    let elementCount = bannerElements.length;
    let currentElement = bannerElements[bannerIndex];

    return <div style={{display: "flex", justifyContent: "row", alignItems: "center", height: "100%",}}>
        <a style={{width: "10%",}} onClick={() => setBannerIndex((bannerIndex - 1 + elementCount) % elementCount)}>&lt;</a>
        {currentElement}
        <a style={{width: "10%",}} onClick={() => setBannerIndex((bannerIndex + 1) % elementCount)}>&gt;</a>
    </div>;
}


const BannerHeaderStyle_NonMobile: any = {marginBottom: "16px", marginLeft: "4px", marginRight: "4px",};
const BannerHeaderStyle_Mobile: any = {marginBottom: "16px", marginLeft: "4px", marginRight: "4px",};
const BannerHeaderStyle: any = IsMobile() ? BannerHeaderStyle_Mobile : BannerHeaderStyle_NonMobile;

const BannerStyle_NonMobile: any = {
    width: "60%", height: "100%",
    fontSize: "0.75rem",
};
const BannerStyle_Mobile: any = {
    width: "80%", height: "100%",
    // padding: "8px",
    fontSize: "0.75rem",
    // display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center",
    backgroundColor: "rgb(118, 66, 138)",
    boxShadow: "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
};
const BannerStyle: any = IsMobile() ? BannerStyle_Mobile : BannerStyle_NonMobile;

// TODO: Coalesce each of these colours into a few central variables. It expands the files needlessly.
const BannerBackgroundStyle_NonMobile = {width: "90%", height: "100%", margin: "auto",
    backgroundColor: "rgb(118, 66, 138)",
    boxShadow: "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",}
const BannerBackgroundStyle_Mobile = {width: "100%", height: "100%", margin: "auto",}
const BannerBackgroundStyle: any = IsMobile() ? BannerBackgroundStyle_Mobile : BannerBackgroundStyle_NonMobile;

// TODO OPTIONAL: Put these in a folder?
//  Get all .jsons in that folder, and make elements outta theme?
//  Or perhaps in the perfect situation, get em from a file server.

// TODO: Find a solution to the displaying of several posts that are scrollable. A Bootstrap carousel?
// TODO OPTIONAL: Can be scrollable.

// These were initially intended to be a single banner data, that shows what is my current Work in Progress.
const homeBannerDatas: HomeBannerData[] = [
    {
        id: "BANNER-SONIC_CHIP_COLLAB_CHAOS",
        title: "Sonic Chip Collab Chaos is Out!",
        panelClickUrl: "https://www.youtube.com/watch?v=Uw_UxP7OmJ4",
        bannerUri: "/Images/Home Page Banners/Sonic Chip Collab Banner.gif",
        isPixelated: false,
    },
    /*{
        id: "BANNER-METAPHOR_JAM_VICTORY",
        title: "Metaphor won a game jam!",
        panelClickUrl: "https://blawnode.itch.io/metaphor-a-dream-journal",
        bannerUri: "/Images/News Exclusive Thumbnails/Metaphor Won Thumbnail.png",
        isPixelated: true,
    },*/
];

const HomeBannerElements: React.JSX.Element[] = [
    ...(homeBannerDatas.map(homeBannerData => (
        <HomeBannerElement key={homeBannerData.id}
                          newsId={homeBannerData.id}
                          title={homeBannerData.title}
                          panelClickUrl={homeBannerData.panelClickUrl}
                          bannerUrl={homeBannerData.bannerUri}
                          isPixelated={homeBannerData.isPixelated}/>))),
];

const HomeBannerPanel = () => {
    const isMobile = IsMobile();

    const homeBannerExpandableContainer_width = 1.75;  // %. Value chosen to accomodate Banner BN perfectly.
    const homeBannerExpandableContainer_height = 1.20;  // %
    const homeBannerExpandableContainer_widthInverse = 1 / homeBannerExpandableContainer_width;
    const homeBannerExpandableContainer_heightInverse = 1 / homeBannerExpandableContainer_height;
    const homeBannerExpandableContainer_left = (1 - homeBannerExpandableContainer_width) / 2;
    const homeBannerExpandableContainer_top = (1 - homeBannerExpandableContainer_height) / 2;
    const homeBannerResizer_top = (homeBannerExpandableContainer_height - homeBannerExpandableContainer_heightInverse) / 4;
    function convertFloatToPercentage(value: number){
        const percentage = value * 100;
        return `${percentage.toFixed(2)}%`;
    }
    // TODO: This can definitely be made more modular.
    // Make a proper, modular resizer element! (It allows elements "inside" it to grow "outside" of it! Like the news panels.)
    const homeBannerExpandableContainer_widthPercentage = convertFloatToPercentage(homeBannerExpandableContainer_width);
    const homeBannerExpandableContainer_heightPercentage = convertFloatToPercentage(homeBannerExpandableContainer_height);
    const homeBannerExpandableContainer_widthInversePercentage = convertFloatToPercentage(homeBannerExpandableContainer_widthInverse);
    const homeBannerExpandableContainer_heightInversePercentage = convertFloatToPercentage(homeBannerExpandableContainer_heightInverse);
    const homeBannerExpandableContainer_leftPercentage = convertFloatToPercentage(homeBannerExpandableContainer_left);
    const homeBannerExpandableContainer_topPercentage = convertFloatToPercentage(homeBannerExpandableContainer_top);
    const homeBannerResizer_topPercentage = convertFloatToPercentage(homeBannerResizer_top);  // When using the new display: flex centering method, the inner "top" is unnecessary.
    
    return <div id="homeBanner" style={{ ...BannerStyle, }}>
        <div id="homeBanner-background" style={{ ...BannerBackgroundStyle, }}>
        </div>
        <div id="homeBanner-foreground" style={{
            position: "relative", top: "-100%",
            height: "100%",
            padding: isMobile ? 0 : "8px",
        }}>
            <div id="homeBanner-expandable-container" style={{
                width: "200%", height: "120%",
                position: "relative", left: "-50%", top: "-10%",
                overflowY: "scroll", scrollbarGutter: "stable both-edges", scrollbarWidth: "none",
                padding: 0,
                display: "flex", justifyContent: "center", alignItems: "center",
            }}>
                <div id="homeBanner-resizer" style={{
                    width: "50%", height: "83.34%", margin: "auto",
                    padding: isMobile ? 0 : "8px",
                }}>
                    <div style={{ fontSize: "calc(3px + 1vmin)", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center",}}>
                        {isMobile ? <HomeBannerElementScroller bannerElements={HomeBannerElements} /> : HomeBannerElements}
                    </div>
                </div>
            </div>
        </div>
        {/* Blawnode avatar + Title */}
        <div id="homeBanner-overlay-ui" style={{
            position: "relative", top: "-200%",
            width: isMobile ? "100%" : "90%", height: "100%", margin: "auto",
            pointerEvents: "none",
        }}>
            <div id="homeBanner-expandable-container" style={{
                width: homeBannerExpandableContainer_widthPercentage, height: homeBannerExpandableContainer_heightPercentage,
                position: "relative", left: homeBannerExpandableContainer_leftPercentage, top: homeBannerExpandableContainer_topPercentage,
                overflowY: "scroll", scrollbarGutter: "stable both-edges", scrollbarWidth: "none",
                padding: 0,
                display: "flex", justifyContent: "center", alignItems: "center",
            }}>
                <div id="homeBanner-resizer" style={{
                    width: homeBannerExpandableContainer_widthInversePercentage, height: homeBannerExpandableContainer_heightInversePercentage, margin: "auto",
                    position: "relative",
                }}>
                    <div style={{ fontSize: "calc(4.5px + 1.5vmin)",
                        width: "100%", height: "100%",
                        position: "relative", top: isMobile ? "calc(-2px - 5% - 0.5em)" : "calc(-2px - 10% - 0.5em)",
                        padding: "8px", }}>
                        <p>Recent relevant thing!</p>
                    </div>
                    <img style={{height: "100%", position: "absolute",
                        top: "50%", right: isMobile ? "calc(100% - 5px)" : "calc(100% - 3px)" /*Approximately 2 pixels?*/, transform: "translateY(-50%)",
                        imageRendering: "pixelated",}} src="UI Graphics/Home Banner Blawnode.png"/>
                </div>
            </div>
        </div>
    </div>;
}

export default HomeBannerPanel;